<div class="container">
  <div class="image">
    <img [src]="src" />
  </div>
  <mat-radio-button
    class="main-picture-radio"
    [checked]="isMainPicture"
    (change)="onSelectMainPicture()">
    Main picture
  </mat-radio-button>
  <button mat-button class="delete-button" (click)="onDeleteButtonClick()">
    <mat-icon>delete</mat-icon> Delete
  </button>
</div>
